import { FOfferType, isSuburban } from '../../../../../../packages/JsonQuery';
import { EQueryParameters_1 } from 'shared/repositories/geo-suggest/v2/suggest';

export function getSuggestOfferType(offerType: FOfferType) {
  if (isSuburban(offerType)) {
    return EQueryParameters_1.Suburban;
  } else if (offerType === FOfferType.FlatNew) {
    return EQueryParameters_1.Newobject;
  } else if ((offerType & FOfferType.Commercial) !== 0) {
    // Для коммерции бэкенд возвращает подсказки БЦ / коворкингов / ТЦ
    return EQueryParameters_1.Commercial;
  }

  return EQueryParameters_1.Flat;
}
